import {
  ReferralAuthorizationTeStatus,
  ReferralAuthorizationWorkflowStatus,
} from "@/src/models/referral-authorization";

export function deriveReferralAuthorizationFromStedi(
  officeVisitRequiresAuth: boolean | null,
  checkFailed: boolean
): {
  teStatus: ReferralAuthorizationTeStatus;
  workflowStatus: ReferralAuthorizationWorkflowStatus;
} {
  if (checkFailed || officeVisitRequiresAuth == null) {
    return {
      teStatus: ReferralAuthorizationTeStatus.STATUS_UNKNOWN,
      workflowStatus: ReferralAuthorizationWorkflowStatus.PENDING,
    };
  }

  if (officeVisitRequiresAuth) {
    return {
      teStatus: ReferralAuthorizationTeStatus.REQUIRED,
      workflowStatus: ReferralAuthorizationWorkflowStatus.PENDING,
    };
  }

  return {
    teStatus: ReferralAuthorizationTeStatus.NOT_REQUIRED,
    workflowStatus: ReferralAuthorizationWorkflowStatus.NOT_REQUIRED,
  };
}
